import { CommonModule } from '@angular/common';
import { NgModule, Pipe, PipeTransform } from '@angular/core';

import { RdsNullParameter, rdsNullParameterIcons } from '../models/filter/null-filter.model';

@Pipe({
  name: 'rdsNullParameterIcon',
})
export class NullParameterIconPipe implements PipeTransform {
  transform(parameter: RdsNullParameter): string {
    if (!parameter) {
      return '';
    }
    return rdsNullParameterIcons[parameter];
  }
}

@NgModule({
  imports: [CommonModule],
  exports: [NullParameterIconPipe],
  declarations: [NullParameterIconPipe],
})
export class RdsNullParameterIconPipeModule {}
